import { render } from "./1.ProductParallax.vue?vue&type=template&id=186e9b04&scoped=true"
import script from "./1.ProductParallax.vue?vue&type=script&lang=js"
export * from "./1.ProductParallax.vue?vue&type=script&lang=js"

import "./1.ProductParallax.vue?vue&type=style&index=0&id=186e9b04&scoped=true&lang=css"
import "./1.ProductParallax.vue?vue&type=style&index=1&id=186e9b04&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186e9b04"]])

export default __exports__